module.exports = __webpack_public_path__ + "img/qrcode-contact.bc7e62e0.jpeg";